import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import DateFilters from "./DateFilters";
import Item from "./Item";
import History from "../../../../../../features/TraxxionProfile/sections/Availability/components/History";
import { getDates, pickIntervals } from "../helpers";
import { useCompanyDateFormat } from "../../../../../../utils/hooks/company";

function Temporary({ query, from, to, mode, setFilters }: any) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    const days = useMemo(() => {
        const entries: any[] = Array.isArray(query?.data) ? query.data : [];
        return entries.reduce((total: Record<string, any[]>, entry) => {
            if (!entry?.day) return total;
            return { ...total, [entry.day]: [...(total[entry.day] || []), entry] };
        }, {});
    }, [query?.data]);

    const dates = useMemo(() => getDates(from, to), [from, to]);

    return (
        <div>
            <DateFilters
                from={from}
                to={to}
                mode={mode}
                setFilters={setFilters}
            />

            <div className="tw-space-y-2">
                {dates.map((day) => {
                    const entries: any[] = days[day] || [];

                    const visible = entries
                        .filter((entry) => entry.status === "pending" || entry.status === "approved")
                        .sort((a, b) => (a.status === b.status ? 0 : a.status === "approved" ? -1 : 1));

                    const history = entries.flatMap((entry) => entry.history || []);

                    return (
                        <div key={day} className="tw-border tw-rounded-xl tw-px-4 tw-py-3 tw-flex tw-items-center tw-gap-4">
                            <div className="tw-shrink-0 tw-w-24">
                                <p className="tw-text-sm tw-font-semibold">{moment(day).format("ddd")}</p>
                                <p className="tw-text-xs tw-text-muted-foreground">{moment(day).format(dateFormat)}</p>
                            </div>

                            <div className="tw-flex-1 tw-min-w-0">
                                {visible.length > 0 ? (
                                    visible.map((entry: any, index: number) => (
                                        <Item
                                            key={entry.id || index}
                                            index={index}
                                            item={{
                                                status: entry.status,
                                                allDay: entry.allDay,
                                                isAvailable: entry.isAvailable,
                                                reason: entry.reason,
                                                shifts: pickIntervals(entry.intervals, entry.isAvailable ?? true),
                                            }}
                                        />
                                    ))
                                ) : (
                                    <p className="tw-text-sm tw-text-muted-foreground tw-m-0">{t("not-set")}</p>
                                )}
                            </div>

                            {history.length > 0 && (
                                <div className="tw-shrink-0 tw-self-start tw-pt-1">
                                    <History title={moment(day).format(dateFormat)} history={history} />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Temporary;
